/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMemo, useContext } from 'react';
import { useObjectAccessModal } from '@/components/ObjectAccess';
import { useDeleteFolderPrompt } from '@/components/Workspace.Folder/hooks/useDeleteFolderPrompt';
import MoveObjectModal from '@/components/WorkspaceObject/MoveObjectModal';
import { WorkspaceObjectType } from '@/enums';
import { useToggle } from '@trinity/chat-components';
import type { WorkspaceFolder, WorkspaceObject } from '@/types/workspace';
import { ObjectAccessContainer } from '../ObjectAccess/ObjectAccessContainer';
import { MoveObjectContainer } from '../WorkspaceObject/MoveObjectContainer';
import { FolderActionsContext, FolderMenuItemsContext } from './Context';
import { useRenameFolderModal } from '@trinity/chat-components/components/Workspace.Folder/hooks/useRenameFolderModal.js';

type Props =
  {
    folder: WorkspaceFolder;
    object: WorkspaceObject;
  } &
  ChildrenProps
  ;

export const FolderActionsContainer = ({ children, folder, object }: Props) => {

  const folderId = folder.id;
  const objectId = object.id;
  const workspaceId = object.workspaceId;

  const menu = useContext(FolderMenuItemsContext);

  // const [toggleNewFolderModal, NewFolderModal] = useNewFolderModal({
  //   location: folder.name,
  //   parentObject: object,
  // });
  // const [toggleOwnershipModal, ObjectOwnershipModal] = useObjectOwnershipModal();
  const [toggleAccessModal, ManageAccessModal] = useObjectAccessModal();
  // const [moveObjectModalOpen, toggleMoveObjectModal] = useToggle();

  // const createProject = useCallback(() => {
  //   history.push(`${consts.path.Projects.New}?parentObjectId=${object.id}`);
  // }, [
  //   history,
  //   object.id,
  // ]);

  const [toggleRenameModal, RenameFolderModal] = useRenameFolderModal();
  const [moveObjectModalOpen, toggleMoveObjectModal] = useToggle();
  const [toggleDeleteFolderPrompt, DeleteFolderPrompt] = useDeleteFolderPrompt();

  const actions = useMemo(() => ({
    changeOwner: () => { }, //toggleOwnershipModal,
    createFolder: () => { }, //toggleNewFolderModal,
    createProject: () => { }, //createProject,
    delete: toggleDeleteFolderPrompt,
    manageAccess: toggleAccessModal,
    rename: toggleRenameModal,
    move: toggleMoveObjectModal,
  }), [
    // createProject,
    toggleAccessModal,
    // toggleNewFolderModal,
    // toggleOwnershipModal,
    toggleRenameModal,
    toggleMoveObjectModal,
    toggleDeleteFolderPrompt,
  ]);


  return (
    <FolderActionsContext.Provider value={actions}>
      {menu.canMove && (
        <MoveObjectContainer
          workspaceId={workspaceId}
          enabled={moveObjectModalOpen}
          objectId={objectId}
          objectType={WorkspaceObjectType.Folder}>
          <MoveObjectModal
            open={moveObjectModalOpen}
            onClose={toggleMoveObjectModal} />
        </MoveObjectContainer>
      )}
      {menu.canRename &&
        <RenameFolderModal workspaceId={workspaceId} folderId={folderId} name={folder.name} />
      }
      {menu.canDelete &&
        <DeleteFolderPrompt workspaceId={workspaceId} folderId={folderId} />
      }
      {menu.canManageAccess &&
        <ObjectAccessContainer objectId={objectId} workspaceId={workspaceId}>
          <ManageAccessModal />
        </ObjectAccessContainer>
      }
      {children}
    </FolderActionsContext.Provider>
  );
  /*
  return (
    <FolderActionsContext.Provider value={actions}>
      {children}
      {menu.canAddChildren &&
        <NewFolderModal />}
      {menu.canManageAccess && (
        <ObjectAccessContainer objectId={objectId} workspaceId={workspaceId}>
          <ManageAccessModal />
        </ObjectAccessContainer>
      )}
      {menu.canManageAccess &&
        <ObjectAccessContainer objectId={objectId} workspaceId={workspaceId}>
          <ManageAccessModal />
        </ObjectAccessContainer>
      }
    </FolderActionsContext.Provider>
      );
    */
};